import { Navigate, Route, Routes } from 'react-router-dom'
import { PipelinesPage } from '../tfi/pages/pipelines/PipelinesPage'
import NotFoundPage from '../tfi/pages/notFound/NotFoundPage'
import { LeadsPage } from '../tfi/pages/leads/LeadsPage'
import { StagePage } from '../tfi/pages/stages/StagePage'
import { LeadLossReasonPage } from '../tfi/pages/leadLossReason/LeadLossReasonPage'
import { TagManagerPage } from '../tfi/pages/tagManager/TagManagerPage'
import { MembersPage } from '../tfi/pages/members/MembersPage'
import { AssignmentGroupsPage } from '../tfi/pages/assignmentGroups/AssignmentGroupsPage'
import { LeadSourcePage } from '../tfi/pages/leadSource/LeadSourcePage'
import { PolicyTypePage } from '../tfi/pages/policyType/PolicyTypePage'
import { OneLeadPage } from '../tfi/pages/oneLead/OneLeadPage'
import { OneAddQuotePage } from '../tfi/pages/oneAddQuote/OneAddQuotePage'
import { OnePolicyPage } from '../tfi/pages/onePolicy/OnePolicyPage'
import { UsersPage } from '../tfi/pages/users/UsersPage'
import { PoliciesPage } from '../tfi/pages/policies/PoliciesPage'
import { CarriersPage } from '../tfi/pages/carriers/CarriersPage'
import { OneUserPage } from '../tfi/pages/oneUser/OneUserPage'
import { OneComissionRate } from '../tfi/pages/oneCarrier/OneComissionRate'
import { useGetUser } from '../tfi/store/userStore'
import { hasPermission } from '../tfi/helpers'
import { ALL_PERMISSIONS } from '../tfi/helpers/consts'
import { IntegrationsPage } from '../tfi/pages/integrations/IntegrationsPage'
import { InboxPage } from '../tfi/pages/chat/InboxPage'
import { ChannelConfigPage } from '../tfi/pages/channelConfig/ChannelConfigPage'
import { OrganizationsPage } from '../tfi/pages/organizations/OrganizationsPage'
import { GoogleOAuthProvider } from '@react-oauth/google'
import { ProfilePage } from '../tfi/pages/profile/ProfilePage'
import { NewDashboardPage } from '../tfi/pages/homeReportsPolicies/NewDashboardPage'
import { ExecutiveDashboardPage } from '../tfi/pages/executiveDashboard/ExecutiveDashboardPage'
import { CommissionReportsPage } from '../tfi/pages/commissionReports/CommissionReportsPage'
import { CommissionReportsDetailsPage } from '../tfi/pages/commissionReportsDetails/CommissionReportsDetailsPage'
import { CommissionReportsPayrollPage } from '../tfi/pages/commissionReportsDetails/CommissionReportsPayrollPage'
import { CommissionReportsPayrollTotalsPage } from '../tfi/pages/commissionReports/CommissionReportsPayrollTotalsPage'
import { CommissionReportsLogsPage } from '../tfi/pages/commissionReportsLogs/CommissionReportsLogsPage'
import { QuotesPage } from '../tfi/pages/quotes/QuotesPage'
import { HomeQuotesPage } from '../tfi/pages/homeReportsQuotes/HomeQuotesPage'
import { MedicareCenterPage } from '../tfi/pages/medicareCenter/MedicareCenterPage'
import { SignatureFormsPage } from '../tfi/pages/signatureForms/SignatureFormsPage'
import { SignatureFormsEntriesPage } from '../tfi/pages/signatureFormsEntries/SignatureFormsEntriesPage'
import { ContactsPage } from '../tfi/pages/contacts/ContactsPage'
import { UserDeductionTypePage } from '../tfi/pages/userDeductionType/UserDeductionTypePage'
import { ResourceCenterPage } from '../tfi/pages/resourceCenter/ResourceCenterPage'
import { KanbanPage } from '../tfi/pages/kanban/KanbanPage'
import { CampaignsPage } from '../tfi/pages/campaigns/CampaignsPage'
import { CampaignDetailPage } from '../tfi/pages/campaigns/CampaignDetailPage'
import { CampaignsMediaPage } from '../tfi/pages/campaigns/CampaignsMediaPage'
import { TemplatesPage } from '../tfi/pages/templates/TemplatesPage'
import { TemplateEditorPage } from '../tfi/pages/templates/TemplateEditorPage'
import { RecipientsPage } from '../tfi/pages/recipients/RecipientsPage'
import { WhatsAppTemplatesPage } from '../tfi/pages/integrations/WhatsAppTemplatesPage'
import { NotificationsPageWrapper } from '../tfi/pages/notifications/NotificationsPageWrapper'
import { AutomationsPage } from '../tfi/pages/automations/AutomationsPage'
import { CalendarPage } from '../tfi/pages/calendar/CalendarPage'
import { AttentionTicketsPage } from '../tfi/pages/attentionTickets/AttentionTicketsPage'
import { TicketFormPage } from '../tfi/pages/attentionTickets/TicketFormPage'
import { canAccessPolicyDashboard, getLandingRoute } from './routeUtils'

const CLIENT_ID = '1005174958588-ht8kplhn013evfjg2de734oc2upk6djp.apps.googleusercontent.com'

export const TFIRoutes = () => {
  const permissions = useGetUser((s) => s.user?.permissions)
  const userGroups = useGetUser((s) => s.user?.groups) || []
  const landingRoute = getLandingRoute({ permissions: permissions || [], userGroups })
  const canViewPolicyDashboard = canAccessPolicyDashboard({
    permissions: permissions || [],
    userGroups,
  })
  return (
    <Routes>
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_PIPELINE) && (
        <Route path='pipelines' element={<PipelinesPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD) && (
        <Route path='leads' element={<LeadsPage />} />
      )}
      <Route path='stages/:id' element={<StagePage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD_LOSS_REASON) && (
        <Route path='/lead-loss-reasons' element={<LeadLossReasonPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_TAG_MANAGER) && (
        <Route path='/tag-manager' element={<TagManagerPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION_DEDUCTION_TYPE) && (
        <Route path='/user-deductions' element={<UserDeductionTypePage />} />
      )}
      <Route path='/members' element={<MembersPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_GROUP_ASSIGNMENT) && (
        <Route path='/assignment-groups' element={<AssignmentGroupsPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD_SOURCE) && (
        <Route path='/lead-sources' element={<LeadSourcePage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY_TYPE) && (
        <Route path='/policy-type-setup' element={<PolicyTypePage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_LEAD) && (
        <Route path='/lead/:id' element={<OneLeadPage />} />
      )}
      <Route path='/quote/:id' element={<OneAddQuotePage />} />
      <Route path='/sold' element={<OnePolicyPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_USER) && (
        <Route path='/users' element={<UsersPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_USER) && (
        <Route path='/user/:id' element={<OneUserPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_POLICY) && (
        <Route path='/policies' element={<PoliciesPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_CARRIER) && (
        <Route path='/carriers' element={<CarriersPage />} />
      )}
      <Route path='/carrier/:id' element={<OneComissionRate />} />

      <Route
        path='/integrations'
        element={
          <GoogleOAuthProvider clientId={CLIENT_ID}>
            <IntegrationsPage />
          </GoogleOAuthProvider>
        }
      />
      <Route path='/integrations/whatsapp-templates' element={<WhatsAppTemplatesPage />} />
      <Route path='/inbox' element={<InboxPage />} />
      <Route path='/channel-config' element={<ChannelConfigPage />} />
      <Route path='/organizations' element={<OrganizationsPage />} />
      <Route path='/profile' element={<ProfilePage />} />
      <Route path='/dashboard/lead' element={<Navigate to={landingRoute} replace />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_COMMISSION) && (
        <Route path='/commissions' element={<CommissionReportsPage />} />
      )}
      <Route path='/commissions/payroll-totals' element={<CommissionReportsPayrollTotalsPage />} />
      <Route path='/commissions/:id/details' element={<CommissionReportsDetailsPage />} />
      <Route path='/commissions/:id/details/:client' element={<CommissionReportsDetailsPage />} />
      <Route path='/commissions/:id/payroll' element={<CommissionReportsPayrollPage />} />
      <Route path='/commissions/:id/conciliation' element={<CommissionReportsLogsPage />} />
      <Route
        path='/dashboard/policy'
        element={
          canViewPolicyDashboard ? (
            <NewDashboardPage />
          ) : (
            <Navigate to={landingRoute} replace />
          )
        }
      />
      <Route path='/dashboard/quote' element={<HomeQuotesPage />} />
      {canViewPolicyDashboard && (
        <Route path='/dashboard/executive' element={<ExecutiveDashboardPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_CONTACT) && (
        <Route path='/medicare-center' element={<MedicareCenterPage />} />
      )}
      {/* <Route path='/one-quote/:id' element={<OneQuotePage />} /> */}
      <Route path='/one-quote/:id' element={<OnePolicyPage />} />
      <Route path='/one-policy/:id' element={<OnePolicyPage />} />
      <Route path='/quotes' element={<QuotesPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_SIGNATURE_FORMS) && (
        <Route path='/signature-forms' element={<SignatureFormsPage />} />
      )}
      <Route path='/signature-forms/:id/entries' element={<SignatureFormsEntriesPage />} />
      <Route path='/contacts' element={<ContactsPage />} />
      <>
        <Route path='/tickets' element={<AttentionTicketsPage />} />
        <Route path='/tickets/new' element={<TicketFormPage />} />
        <Route path='/tickets/:id' element={<TicketFormPage />} />
        <Route path='/attention-tickets' element={<Navigate to='/tickets' replace />} />
        <Route path='/tickets-atencion' element={<Navigate to='/tickets' replace />} />
      </>
      <Route path='/notifications' element={<NotificationsPageWrapper />} />
      <Route path='/calendar' element={<CalendarPage />} />
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_RESOURCE_CENTER) && (
        <Route path='/resource-center' element={<ResourceCenterPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_TASKS) && (
        <Route path='/kanban' element={<KanbanPage />} />
      )}
      {permissions && hasPermission(permissions, ALL_PERMISSIONS.VIEW_CAMPAIGNS) && (
        <>
          <Route path='/campaigns' element={<CampaignsPage />} />
          <Route path='/campaigns/:id' element={<CampaignDetailPage />} />
          <Route path='/campaigns/templates' element={<TemplatesPage />} />
          <Route path='/templates' element={<TemplatesPage />} />
          <Route path='/templates/edit/:id' element={<TemplateEditorPage />} />
          <Route path='/recipients' element={<RecipientsPage />} />
          <Route path='/media-manager' element={<CampaignsMediaPage />} />
          <Route path='/automations' element={<AutomationsPage />} />
        </>
      )}
      <Route path='*' element={<NotFoundPage />} />
    </Routes>
  )
}
